import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  adminApi,
  UpdateMemberRoleRequest,
  UpdateMemberRoleResponse
} from 'services/adminApi';

interface UseUpdateMemberRoleParams {
  companyId: string;
  userId: string;
}

/**
 * Hook to update a company member's role
 * Requires company ID and the member's user ID
 */
export const useUpdateMemberRole = (
  { companyId, userId }: UseUpdateMemberRoleParams,
  options?: UseMutationOptions<
    UpdateMemberRoleResponse,
    Error,
    UpdateMemberRoleRequest
  >
) => {
  return useMutation<UpdateMemberRoleResponse, Error, UpdateMemberRoleRequest>({
    mutationFn: (data: UpdateMemberRoleRequest) =>
      adminApi.updateMemberRole(companyId, userId, data),
    ...options,
  });
};
